import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { db } from "@/lib/firebase";
import { collection, getDocs } from "firebase/firestore";

const Schedule: React.FC = () => {
	const [sessions, setSessions] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchSessions = async () => {
			setLoading(true);
			setError(null);
			try {
				const querySnapshot = await getDocs(collection(db, "schedule"));
				const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
				setSessions(data);
			} catch (err: any) {
				setError("Failed to load schedule.");
			} finally {
				setLoading(false);
			}
		};
		fetchSessions();
	}, []);

	return (
		<div>
			<h2 className="text-2xl font-bold mb-4">Schedule Management</h2>
			<Button className="mb-4">Add Session</Button>
			<Card>
				<CardHeader>
					<CardTitle>All Scheduled Sessions</CardTitle>
				</CardHeader>
				<CardContent>
					{loading ? (
						<div className="py-8 text-center text-muted-foreground">Loading...</div>
					) : error ? (
						<div className="py-8 text-center text-destructive">{error}</div>
					) : sessions.length === 0 ? (
						<div className="py-8 text-center text-muted-foreground">No sessions yet.</div>
					) : (
						<div className="border rounded-md">
							<div className="grid grid-cols-6 font-medium p-3 border-b bg-muted/50">
								<div>Date</div>
								<div>Time</div>
								<div>Student</div>
								<div>Instructor</div>
								<div>Course</div>
								<div>Actions</div>
							</div>
							<div className="divide-y">
								{sessions.map((s) => (
									<div key={s.id} className="grid grid-cols-6 p-3">
										<div>{s.date}</div>
										<div>{s.time}</div>
										<div>{s.student}</div>
										<div>{s.instructor}</div>
										<div>{s.course}</div>
										<div>
											<Button variant="ghost" size="sm">
												Edit
											</Button>
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</CardContent>
			</Card>
		</div>
	);
};

export default Schedule;
